<div class="content-iframe">
  <iframe
    #frame
    width="100%"
    height="100%"
    id="frame"
    name="frame"
    title="Logalty"
    [src]="signatureURL"
    (load)="onLoad()"
  ></iframe>

  <form target="frame" action="{{ url }}" #formLogalty method="POST" (ngSubmit)="submitForm($event)">
    <input type="hidden" name="saml_assertion" value="{{ saml }}" id="saml_assertion" />
  </form>
</div>
